// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"294":"5cd5c942","315":"3bffcad9","787":"c4e7f8f9","923":"7565c8ac"}[chunkId] + ".chunk.js";
};